import { Row, Col, Table, Spinner } from 'react-bootstrap';
import {useState, useEffect} from 'react';

export default function ServidoresRemuneracao() {
    let [cargosComAdm, setCargosComAdm] = useState([]);
    let [cargosComGab, setCargosComGab] = useState([]);
    let [cargosEfetivos, setCargosEfetivos] = useState([]);
    let [cargosExtintos, setCargosExtintos] = useState([]);
    let [loading, setLoading] = useState(true);

    useEffect(()=> {
        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/cargos2.php?escopo=adm").then(result => {
            result.json().then(data => {
                setCargosComAdm(data);
                setLoading(false);
            });
        });


        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/cargos2.php?escopo=gab").then(result => {
            result.json().then(data => {
                setCargosComGab(data);
            });
        });

        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?cargo=CEIa&pccs=1").then(result => {
            result.json().then(data => {
                setCargosEfetivos(current => [...current, data[0]]);
            });
        });

        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?cargo=CEIIa&pccs=1").then(result => {
            result.json().then(data => {
                setCargosEfetivos(current => [...current, data[0]]);
            });
        });

        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?cargo=CEIIIa&pccs=1").then(result => {
            result.json().then(data => {
                setCargosEfetivos(current => [...current, data[0]]);
            });
        });

        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?cargo=CEIVa&pccs=1").then(result => {
            result.json().then(data => {
                setCargosEfetivos(current => [...current, data[0]]);
            });
        });

        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?cargo=CEGS19a&pccs=1").then(result => {
            result.json().then(data => {
                setCargosEfetivos(current => [...current, data[0]]);
                console.log(cargosEfetivos);
            });
        });

        fetch("https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?pccs=2").then(result => {
            result.json().then(data => {
                setCargosExtintos(data);
            });
        });

    }, []);
    
    return <div>
        <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/pessoal">Gestão de Pessoas</a> / Tabelas de Remuneração</small></p>
        </Col>
        {!loading ? 
            <Col xs="12">
                <Row>
                    <Col xs={{spam: 2, offset: 10}} className='mb-2 text-center'>
                        <div>
                            <a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/cargos2.php?escopo=adm&formato=csv" title="Download em CSV"><img src="/img/download-csv.png" height="16" width="16" alt=""/>CSV</a>
                            {/*<a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/funcionarios.php?pccs=1&formato=pdf" style={{marginLeft: '10px'}} title="Download em PDF"><img src="/img/download-pdf.png" height="16" width="16" alt=""/>PDF</a>*/}
                        </div>
                    </Col>
                </Row>
                <div className="table-responsive">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Cargos Comissionados Administrativos</th>
                                <th>Subsídio</th>
                            </tr>
                        </thead>
                        <tbody>
                                {
                                    cargosComAdm.map((cargo) => {
                                        return <tr>
                                            <td>{cargo.nome}</td>
                                            <td>R${Number(cargo.salario).toFixed(2)}</td>
                                        </tr>
                                        
                                    })
                                }
                        </tbody>
                        <tfooter>
                            <tr>
                                <td colspan="3">A remuneração dos cargos comissionados administrativos é composta de Vencimento e Gratificação de Representação, já totalizados nos valores acima.</td>
                            </tr>
                        </tfooter>
                    </Table>
                </div>
            </Col> : <Col xs="12" className='text-center'><Spinner/></Col>}
        </Row>
        <Row>
            <Col xs="12">
                <Row>
                    <Col xs={{spam: 2, offset: 10}} className='mb-2 text-center'>
                        <div>
                            <a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/cargos2.php?escopo=gab&formato=csv" title="Download em CSV"><img src="/img/download-csv.png" height="16" width="16" alt=""/>CSV</a>
                            {/*<a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/funcionarios.php?pccs=1&formato=pdf" style={{marginLeft: '10px'}} title="Download em PDF"><img src="/img/download-pdf.png" height="16" width="16" alt=""/>PDF</a>*/}
                        </div>
                    </Col>
                </Row>
                <div className="table-responsive">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Cargos Comissionados de Gabinete</th>
                                <th>Vencimento</th>
                            </tr>
                        </thead>
                        <tbody>
                                {
                                    cargosComGab.map((cargo) => {
                                        return <tr>
                                            <td>{cargo.nome}</td>
                                            <td>R${Number(cargo.salario).toFixed(2)}</td>
                                        </tr>
                                        
                                    })
                                }
                        </tbody>
                        <tfooter>
                            <tr>
                                <td colspan="3">Além do Vencimento acima, a remuneração dos cargos comissionados de gabinete inclui Gratificação de Representação variável de 0 a 120%.</td>
                            </tr>
                        </tfooter>
                    </Table>
                </div>
            </Col>
        </Row>
        <Row>
            <Col xs="12">
                <Row>
                    <Col xs={{spam: 2, offset: 10}} className='mb-2 text-center'>
                        <div>
                            <a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos2.php?pccs=1&formato=csv" title="Download em CSV"><img src="/img/download-csv.png" height="16" width="16" alt=""/>CSV</a>
                            {/*<a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/funcionarios.php?pccs=1&formato=pdf" style={{marginLeft: '10px'}} title="Download em PDF"><img src="/img/download-pdf.png" height="16" width="16" alt=""/>PDF</a>*/}
                        </div>
                    </Col>
                </Row>
                <div className="table-responsive">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Cargos Efetivos</th>
                                <th>Subsídio</th>
                            </tr>
                        </thead>
                        <tbody>
                                {
                                    cargosEfetivos.map((cargo) => {
                                        if (cargo) {
                                            return <tr>
                                                <td>{cargo.nome}</td>
                                                <td>R${Number(cargo.salario).toFixed(2)}</td>
                                            </tr>

                                        }
                                        
                                    })
                                }
                        </tbody>
                        <tfooter>
                            <tr>
                                <td colspan="3">A remuneração dos procuradores é composta de Vencimento, Gratificação de Representação e Gratificação de Produtividade, já totalizados nos valores acima.</td>
                            </tr>
                        </tfooter>
                    </Table>
                </div>
            </Col>
        </Row>
        <Row>
            <Col xs="12">
                <Row>
                    <Col xs={{spam: 2, offset: 10}} className='mb-2 text-center'>
                        <div>
                            <a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/tabelasalariosefetivos.php?pccs=2&formato=csv" title="Download em CSV"><img src="/img/download-csv.png" height="16" width="16" alt=""/>CSV</a>
                            {/*<a href="https://www.alepe.pe.gov.br/servicos/transparencia/fun/funcionarios.php?pccs=1&formato=pdf" style={{marginLeft: '10px'}} title="Download em PDF"><img src="/img/download-pdf.png" height="16" width="16" alt=""/>PDF</a>*/}
                        </div>
                    </Col>
                </Row>
                <div className="table-responsive">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Cargos Extintos Após Vacância</th>
                                <th>Vencimento</th>
                            </tr>
                        </thead>
                        <tbody>
                                {
                                    cargosExtintos.map((cargo) => {
                                        return <tr>
                                            <td>{cargo.nome}</td>
                                            <td>R${Number(cargo.salario).toFixed(2)}</td>
                                        </tr>
                                        
                                    })
                                }
                        </tbody>
                        <tfooter>
                            <tr>
                                <td colspan="3"><a href="https://legis.alepe.pe.gov.br/arquivoTexto.aspx?tiponorma=1&numero=12777&complemento=0&ano=2005&tipo=" rel="noopener" target="_blank">(ART. 30, LEI 12.777)</a></td>
                            </tr>
                        </tfooter>
                    </Table>
                </div>
            </Col>
        </Row>
    </div>
}